import { StaffOverviewScreen } from "@/features/staff";

export default StaffOverviewScreen;
